import React, { useEffect } from 'react'
import cn from 'classnames'
import { Cross } from '@components/icons'
import { Button } from '@corratech/pylot-ui'
import { useTranslation } from 'next-i18next/pages'
import s from './SidebarFilter.module.scss'
import { FilterWrapperProps } from '../FilterTypes'

export const SidebarFilter = (props: FilterWrapperProps): JSX.Element => {
    const { t } = useTranslation(['plp'])

    const {
        subCategories,
        filtersApplied,
        applyFilter,
        filtersVisible,
        setFiltersVisible,
        isAccordion,
        filtersList,
        appliedFilterList,
        className
    } = props

    useEffect(() => {
        // Libera el bloqueo del body y vuelve al scroll previo. Se usa tanto al
        // cerrar el panel como al desmontar con el panel abierto (p. ej. botón
        // "atrás" de Android): antes el body quedaba `position: fixed` en la
        // página destino y no se podía hacer scroll.
        const releaseBodyScrollLock = () => {
            const scrollY = document.body.style.top
            document.body.style.position = ''
            document.body.style.top = ''
            document.body.style.left = ''
            document.body.style.right = ''
            document.body.style.overflow = ''

            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1)
            }
        }

        if (filtersVisible) {
            const scrollY = window.scrollY
            document.body.style.position = 'fixed'
            document.body.style.top = `-${scrollY}px`
            document.body.style.left = '0'
            document.body.style.right = '0'
            document.body.style.overflow = 'hidden'

            const intervalId = setInterval(() => {
                const launcher = document.getElementById('launcher')
                if (launcher) {
                    launcher.style.display = 'none'
                    clearInterval(intervalId)
                }
            }, 1000)
            return () => {
                clearInterval(intervalId)
                releaseBodyScrollLock()
            }
        }

        releaseBodyScrollLock()
        return undefined
    }, [filtersVisible])

    if (!filtersVisible) return <></>

    return (
        <>
            {filtersVisible && (
                <div
                    className={s['filter-overlay']}
                    onClick={() => setFiltersVisible(false)}
                    aria-hidden="true"
                />
            )}
            <div
                className={cn(
                    s['layered-navigations'],
                    filtersVisible && s['open'],
                    className,
                    'animate-fade-in-right md:animate-fade-in-down'
                )}
            >
                <div>{subCategories}</div>
                <div className={cn(s['filters-list'])}>
                    <div className={cn(s['filter-mob'], 'filter-mob')}>
                        <h4>{t('toolbar|Filter By')}</h4>
                        <Button
                            variant="link"
                            className={cn(s['cart-btn-close'], 'close-btn')}
                            aria-label={t('Close Panel')}
                            onClick={() => setFiltersVisible(false)}
                        >
                            <Cross />
                        </Button>
                    </div>
                    <div
                        className={cn(
                            s['filter-body'],
                            'filter-body',
                            isAccordion
                                ? s['accordion-filter-body']
                                : s['non-accordion-filter-body']
                        )}
                    >
                        {filtersApplied > 0 && (
                            <div className={s['filter-div']}>
                                <div className={s['filter-wrapper']}>
                                    <div className={s['filtered-by']}>
                                        {t('Filtered by:')}
                                    </div>
                                    <div className={s['selected-items-list']}>
                                        <Button
                                            onClick={() => applyFilter()}
                                            variant="link"
                                            className={
                                                s['selected-items-clear-all']
                                            }
                                        >
                                            {t('Clear all')}
                                        </Button>
                                    </div>
                                </div>
                                {appliedFilterList}
                            </div>
                        )}
                        <p className={s['line-header']} />
                        <div>{subCategories}</div>
                        <ul>{filtersList}</ul>
                    </div>
                </div>
                {filtersVisible && (
                    <div className={cn(s['apply-filters'])}>
                        <Button
                            variant="secondary"
                            disabled={filtersApplied === 0}
                            onClick={() => applyFilter()}
                        >
                            {t('toolbar|Reset')}
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={() => setFiltersVisible(false)}
                        >
                            {t('toolbar|Apply')}
                        </Button>
                    </div>
                )}
            </div>
        </>
    )
}
